<template>
  <div class="bg--color-02 flx--grow-1">
    <div class="exchange-page container-new pb-48 pb-100--l pt-32 pt-48--l">
      <div class="exchange-page__info mb-40 mb-28--l">
        <h1
          class="about-text-block__title txt--bold txt--26px txt--52px--l txt--height-34px txt--height-64px--l txt--color-04 mb-10 mb-16--l"
        >
          {{ $t('exchange.blockTitle') }}
        </h1>
        <p
          class="about-text-block__desc txt--color-03 txt--14px txt--22px--l txt--height-18px txt--height-30px--l mb-0"
        >
          {{ $t('exchange.blockDescription') }}
        </p>
      </div>

      <div class="exchange-page__form-with-image">
        <img
          class="exchange-page__image"
          :src="require('assets/img/exchange/image.svg')"
        >
        <div class="exchange-page__form">
          <exchange-swap-form-new
            class="exchange-page__swap"
            @pair-change="onPairChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { getDefaultHeadData } from '@/lib/utils'

export default {
  name: 'Exchange',
  components: {
    ExchangeSwapFormNew: () =>
      import(
        /* webpackMode: "eager" */ '@/components/exchange/ExchangeSwapFormNew.vue'
      ),
  },
  head () {
    return getDefaultHeadData({
      title: this.$t('meta.quickExchange.title'),
      description: this.$t('meta.quickExchange.description'),
      locale: this.$i18n.locale,
    })
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.auth.loggedIn,
    }),
  },
  async beforeMount () {
    this.$api.$marketSubscribe()
    if (this.isLoggedIn) {
      await this.$store.dispatch('wallet/getWalletBalances')
    }
  },
  beforeDestroy () {
    this.$api.$marketUnsubscribe()
    // TODO: removed because "this.$api.$unsubscribeMarket() is not a function"
    // this.$api.$unsubscribeMarket()
    this.$api.$unsubscribeAssets()
  },
  methods: {
    ...mapActions('exchange', ['fetchMarketPrice']),
    ...mapActions({
      initProfileOrders: 'profile/orders/initProfileOrders',
      subscribeOnPairChange: 'pairs/subscribeOnPairChange',
    }),
    async onPairChange (pair) {
      if (!pair) {
        return null
      }

      const tickers = pair.split('_')
      await this.subscribeOnPairChange({ pair })
      await this.fetchMarketPrice(pair)

      if (this.isLoggedIn) {
        await this.$api.$unsubscribeAssets()
        await this.$api.$subscribeAssets({ tickers })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.exchange-page {
  &__form-with-image {
    display: grid;
    grid-template-areas: 'image' 'form';
    grid-template-columns: 1fr;
    gap: toRem(40px);

    @include bp(l) {
      gap: toRem(45px);
      grid-template-areas: 'form image';
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__form {
    grid-area: form;
    display: grid;
    grid-template-columns: 1fr;
    gap: toRem(58px);

    @include bp(l) {
      width: 100%;
      max-width: toRem(498px);
      margin-right: auto;
      flex: 1;
    }
  }

  &__image {
    grid-area: image;
    width: 100%;
    max-width: toRem(572px);
    margin: 0 auto;
    flex: 1;

    @include bp(l) {
      margin: auto 0;
    }
  }

  &__swap {
    align-self: center;
  }
}
</style>
